module.exports = __webpack_public_path__ + "static/fonts/PorscheNextPersianTT-Regular.d39c9e57.ttf";